import React from 'react';
import styled from 'styled-components';
import { FilterOutlined } from '@ant-design/icons';

const CollapseTitle: React.FC = ({ children }) => {
  return (
    <Title>
      <FilterOutlined /> {children}
    </Title>
  );
};

export default CollapseTitle;

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #00b1f1;
  * {
    color: #00b1f1;
  }
`;
